"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeResponseAllOfToJSON = exports.ChallengeResponseAllOfFromJSONTyped = exports.ChallengeResponseAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ChallengeResponseAllOfFromJSON(json) {
    return ChallengeResponseAllOfFromJSONTyped(json, false);
}
exports.ChallengeResponseAllOfFromJSON = ChallengeResponseAllOfFromJSON;
function ChallengeResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'cardTitle': !(0, runtime_1.exists)(json, 'cardTitle') ? undefined : json['cardTitle'],
        'description': json['description'],
        'backgroundImageLarge': !(0, runtime_1.exists)(json, 'backgroundImageLarge') ? undefined : json['backgroundImageLarge'],
        'backgroundImageSmall': !(0, runtime_1.exists)(json, 'backgroundImageSmall') ? undefined : json['backgroundImageSmall'],
        'brandLogo': !(0, runtime_1.exists)(json, 'brandLogo') ? undefined : json['brandLogo'],
        'brandColor': !(0, runtime_1.exists)(json, 'brandColor') ? undefined : json['brandColor'],
        'rewardConfigs': !(0, runtime_1.exists)(json, 'rewardConfigs') ? undefined : (json['rewardConfigs'].map(_1.RewardConfigResponseFromJSON)),
        'start': json['start'],
        'end': json['end'],
        'hasEnded': !(0, runtime_1.exists)(json, 'hasEnded') ? undefined : json['hasEnded'],
        'isActive': !(0, runtime_1.exists)(json, 'isActive') ? undefined : json['isActive'],
        'instantRewardQuest': !(0, runtime_1.exists)(json, 'instantRewardQuest') ? undefined : json['instantRewardQuest'],
        'numberOfEntrants': !(0, runtime_1.exists)(json, 'numberOfEntrants') ? undefined : json['numberOfEntrants'],
        'showChallengeCompleteNotification': !(0, runtime_1.exists)(json, 'showChallengeCompleteNotification') ? undefined : json['showChallengeCompleteNotification'],
        'showInstantRewardQuestCompleteNotification': !(0, runtime_1.exists)(json, 'showInstantRewardQuestCompleteNotification') ? undefined : json['showInstantRewardQuestCompleteNotification'],
        'challengeCompleteNotificationMessage': !(0, runtime_1.exists)(json, 'challengeCompleteNotificationMessage') ? undefined : json['challengeCompleteNotificationMessage'],
        'instantRewardQuestCompleteNotificationMessage': !(0, runtime_1.exists)(json, 'instantRewardQuestCompleteNotificationMessage') ? undefined : json['instantRewardQuestCompleteNotificationMessage'],
        'termsUrl': !(0, runtime_1.exists)(json, 'termsUrl') ? undefined : json['termsUrl'],
        'onboardingSection': !(0, runtime_1.exists)(json, 'onboardingSection') ? undefined : (0, _1.ChallengeOnboardingFromJSON)(json['onboardingSection']),
        'faqs': !(0, runtime_1.exists)(json, 'faqs') ? undefined : (json['faqs'].map(_1.ChallengeFaqDetailsFromJSON)),
        'prizePoolFeatureImage': !(0, runtime_1.exists)(json, 'prizePoolFeatureImage') ? undefined : json['prizePoolFeatureImage'],
        'titleFontSize': !(0, runtime_1.exists)(json, 'titleFontSize') ? undefined : json['titleFontSize'],
        'questConfigIds': !(0, runtime_1.exists)(json, 'questConfigIds') ? undefined : json['questConfigIds'],
        'brandMapSlug': !(0, runtime_1.exists)(json, 'brandMapSlug') ? undefined : json['brandMapSlug'],
    };
}
exports.ChallengeResponseAllOfFromJSONTyped = ChallengeResponseAllOfFromJSONTyped;
function ChallengeResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'cardTitle': value.cardTitle,
        'description': value.description,
        'backgroundImageLarge': value.backgroundImageLarge,
        'backgroundImageSmall': value.backgroundImageSmall,
        'brandLogo': value.brandLogo,
        'brandColor': value.brandColor,
        'rewardConfigs': value.rewardConfigs === undefined ? undefined : (value.rewardConfigs.map(_1.RewardConfigResponseToJSON)),
        'start': value.start,
        'end': value.end,
        'hasEnded': value.hasEnded,
        'isActive': value.isActive,
        'instantRewardQuest': value.instantRewardQuest,
        'numberOfEntrants': value.numberOfEntrants,
        'showChallengeCompleteNotification': value.showChallengeCompleteNotification,
        'showInstantRewardQuestCompleteNotification': value.showInstantRewardQuestCompleteNotification,
        'challengeCompleteNotificationMessage': value.challengeCompleteNotificationMessage,
        'instantRewardQuestCompleteNotificationMessage': value.instantRewardQuestCompleteNotificationMessage,
        'termsUrl': value.termsUrl,
        'onboardingSection': (0, _1.ChallengeOnboardingToJSON)(value.onboardingSection),
        'faqs': value.faqs === undefined ? undefined : (value.faqs.map(_1.ChallengeFaqDetailsToJSON)),
        'prizePoolFeatureImage': value.prizePoolFeatureImage,
        'titleFontSize': value.titleFontSize,
        'questConfigIds': value.questConfigIds,
        'brandMapSlug': value.brandMapSlug,
    };
}
exports.ChallengeResponseAllOfToJSON = ChallengeResponseAllOfToJSON;
